import React from "react";
import moment from "moment/moment";

import {Label} from "../util/label/Label";


function formatDate(value: moment.Moment): string {
    return value.format('YYYY-MM-DD HH:mm')
}

function formatBoolean(value: boolean): JSX.Element {
    if (value) {
        return <Label text={"Да"} variant={"success"}/>
    }
    return <Label text={"Нет"} variant={"error"}/>
}

export {formatDate, formatBoolean}